<div class="resume" [style.font-family]="font" [style.--themeColor]="color">
  <div class="header" [ngClass]="{ 'with-image': data.config.photoUrl }">
    <div class="profile-img" *ngIf="data?.config?.photoUrl">
      <img [src]="data.config.photoUrl" alt="profile" crossorigin="anonymous" />
    </div>

    <div class="header-content">
      <h1 *ngIf="data?.personal_info?.fullName">
        {{ data.personal_info.fullName }}
      </h1>

      <p class="role" *ngIf="data?.targetRole" [style.color]="color">
        {{ data.targetRole }}
      </p>

      <div
        class="info me-4"
        *ngIf="
          data?.personal_info?.email ||
          data?.personal_info?.phone ||
          data?.personal_info?.location ||
          data?.personal_info?.linkedinUrl ||
          data?.personal_info?.githubUrl
        "
      >
        <span *ngIf="data?.personal_info?.email">
          <i class="bi bi-envelope-fill"></i>
          {{ data.personal_info.email }}
        </span>

        <span *ngIf="data?.personal_info?.phone">
          <i class="bi bi-telephone-fill"></i>
          {{ data.personal_info.phone }}
        </span>

        <span *ngIf="data?.personal_info?.location">
          <i class="bi bi-geo-alt-fill"></i>
          {{ data.personal_info.location }}
        </span>

        <span *ngIf="data?.personal_info?.linkedinUrl">
          <i class="bi bi-linkedin"></i>
          {{ data.personal_info.linkedinUrl }}
        </span>

        <span *ngIf="data?.personal_info?.githubUrl">
          <i class="bi bi-github"></i>
          {{ data.personal_info.githubUrl }}
        </span>
      </div>
    </div>
  </div>

  <hr class="divider" [style.background]="color" />

  <div class="body">
    <div class="left">
      <div class="section" *ngIf="data?.summary">
        <h3 [style.color]="color">SUMMARY</h3>
        <p>{{ data.summary }}</p>
      </div>

      <div class="section" *ngIf="data?.education?.length">
        <h3 [style.color]="color">EDUCATION</h3>

        <ng-container *ngFor="let e of data.education">
          <div
            class="item"
            *ngIf="e?.degree || e?.collegeName || e?.startYear || e?.endYear"
          >
            <div class="row" *ngIf="e?.degree || e?.startYear || e?.endYear">
              <strong *ngIf="e?.degree">{{ e.degree }}</strong>

              <span *ngIf="e?.startYear || e?.endYear">
                <ng-container *ngIf="e?.startMonth || e?.startYear">
                  {{ e.startMonth }} {{ e.startYear }}
                </ng-container>

                <span *ngIf="e?.startYear && e?.endYear"> - </span>

                <ng-container *ngIf="e?.endMonth || e?.endYear">
                  {{ e.endMonth }} {{ e.endYear }}
                </ng-container>
              </span>
            </div>

            <p *ngIf="e?.collegeName || e?.location">
              {{ e.collegeName }}
              <span *ngIf="e?.collegeName && e?.location">, </span>
              {{ e.location }}
            </p>

            <p *ngIf="e?.cgpa_or_percentage">
              CGPA: {{ e.cgpa_or_percentage }}
            </p>
          </div>
        </ng-container>
      </div>

      <div class="section" *ngIf="data?.projects?.length">
        <h3 [style.color]="color">PROJECTS</h3>
        <ng-container *ngFor="let p of data.projects">
          <div class="item" *ngIf="p?.title || p?.description">
            <strong *ngIf="p?.title">{{ p.title }}</strong>

            <p class="italic" *ngIf="p?.technologies?.length">
              {{ p.technologies.join(", ") }}
            </p>

            <p *ngIf="p?.description">{{ p.description }}</p>

            <p class="link" *ngIf="p?.outcome">↗ {{ p.outcome }}</p>
          </div>
        </ng-container>
      </div>

      <div
        class="skills-box"
        *ngIf="
          data?.skills?.technicalSkills?.length ||
          data?.skills?.tools?.length ||
          data?.skills?.softSkills?.length
        "
      >
        <h3 [style.color]="color">SKILLS</h3>

        <div class="skill-group" *ngIf="data.skills.technicalSkills.length">
          <strong>Technical</strong>
          <span>{{ data.skills.technicalSkills.join(", ") }}</span>
        </div>

        <div class="skill-group" *ngIf="data.skills.tools.length">
          <strong>Tools</strong>
          <span>{{ data.skills.tools.join(", ") }}</span>
        </div>

        <div class="skill-group" *ngIf="data.skills.softSkills.length">
          <strong>Soft Skills</strong>
          <span>{{ data.skills.softSkills.join(", ") }}</span>
        </div>
      </div>
    </div>

    <div class="right">
      <div class="section" *ngIf="data?.experience?.length">
        <h3 [style.color]="color">EXPERIENCE</h3>
        <ng-container *ngFor="let e of data.experience">
          <div class="item" *ngIf="e?.role || e?.company">
            <div class="row" *ngIf="e?.role || e?.startYear">
              <strong *ngIf="e?.role">{{ e.role }}</strong>

              <span *ngIf="e?.startYear || e?.endYear || e?.currently_working">
                <ng-container *ngIf="e?.startMonth || e?.startYear">
                  {{ e.startMonth }} {{ e.startYear }}
                </ng-container>

                <span
                  *ngIf="e?.startYear && (e?.endYear || e?.currently_working)"
                >
                  -
                </span>

                <ng-container *ngIf="e?.currently_working"
                  >Present</ng-container
                >

                <ng-container *ngIf="!e?.currently_working">
                  {{ e.endMonth }} {{ e.endYear }}
                </ng-container>
              </span>
            </div>

            <p *ngIf="e?.company || e?.location">
              {{ e.company }}
              <span *ngIf="e?.company && e?.location">, </span>
              {{ e.location }}
            </p>

            <p *ngIf="e?.description">{{ e.description }}</p>
          </div>
        </ng-container>
      </div>

      <div class="section" *ngIf="data?.extras?.certifications?.length">
        <h3 [style.color]="color">CERTIFICATIONS</h3>

        <ng-container *ngFor="let c of data.extras.certifications">
          <p *ngIf="c?.name || c?.platform || c?.year">
            <span *ngIf="c?.name">• {{ c.name }}</span>

            <span *ngIf="c?.platform || c?.year">
              ({{ c.platform }}
              <span *ngIf="c?.platform && c?.year"> - </span>
              {{ c.year }})
            </span>
          </p>
        </ng-container>
      </div>

      <div class="section" *ngIf="data?.extras?.awards?.length">
        <h3 [style.color]="color">AWARDS</h3>

        <ng-container *ngFor="let a of data.extras.awards">
          <p *ngIf="a?.name || a?.organization">
            • {{ a.name }}
            <span *ngIf="a?.organization">({{ a.organization }})</span>
          </p>
        </ng-container>
      </div>

      <div class="section" *ngIf="data?.extras?.hackathons?.length">
        <h3 [style.color]="color">HACKATHONS</h3>

        <ng-container *ngFor="let h of data.extras.hackathons">
          <p *ngIf="h?.name || h?.rank">
            <span *ngIf="h?.name">• {{ h.name }}</span>

            <span *ngIf="h?.rank"> ({{ h.rank }}) </span>
          </p>
        </ng-container>
      </div>

      <div class="section" *ngIf="data?.extras?.languages?.length">
        <h3 [style.color]="color">LANGUAGES</h3>

        <ng-container *ngFor="let l of data.extras.languages">
          <p *ngIf="l?.name">
            <span *ngIf="l?.name">• {{ l.name }}</span>

            <span *ngIf="l?.proficiency"> ({{ l.proficiency }}) </span>
          </p>
        </ng-container>
      </div>
    </div>
  </div>
</div>
